import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import { passwordless } from '../utils/magicLink';

/**
 * O modal (ou a página /forgot-password do Canela) ainda pode ser aberto por
 * um link antigo ou por outra extensão: sem senha, ele explica e leva ao login.
 */
export default function extendForgotPasswordModal() {
  extend('flarum/forum/components/ForgotPasswordModal', 'fields', function (items) {
    if (!passwordless()) return;
    Object.keys(items.toObject()).forEach(key => items.remove(key));
    items.add('magicLinkHint', m("p", {
      className: "helpText"
    }, app.translator.trans('ramon-magic-link.forum.forgot_password.passwordless_text')), 20);
    items.add('magicLinkLogIn', m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "button",
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
    }, app.translator.trans('ramon-magic-link.forum.forgot_password.log_in_button'))), 10);
  });
  override('flarum/forum/components/ForgotPasswordModal', 'className', function (original) {
    return passwordless() ? `${original()} MagicLink--passwordless` : original();
  });
  override('flarum/forum/components/ForgotPasswordModal', 'onsubmit', function (original, e) {
    if (!passwordless()) return original(e);
    e.preventDefault();
  });
}
flarum.reg.add('ramon-magic-link', 'forum/extenders/extendForgotPasswordModal', extendForgotPasswordModal);